import React from "react";
import { Select, Input } from "antd";

const { Option } = Select;

interface CountryOption {
  label: string; // Country code, e.g. "IN"
  value: string; // Dialing code, e.g. "+91"
}

interface PhoneInputWithCountryCodeProps {
  countryCode: string;
  onCountryCodeChange: (value: string) => void;
  phoneNumber: string;
  onPhoneNumberChange: (value: string) => void;
  countryOptions: CountryOption[];
  placeholder?: string;
  label?: string;
  error?: string;
  labelClassName?: string;
  required?: boolean;
}

const PhoneInputWithCountryCode: React.FC<PhoneInputWithCountryCodeProps> = ({
  countryCode,
  onCountryCodeChange,
  phoneNumber,
  onPhoneNumberChange,
  countryOptions,required=false,
  placeholder = "1234 4567",label,labelClassName,error=''
}) => {
  return (
    <div className="flex flex-col">
         {label && (
                <label className={`block common-label pb-[6px] ${labelClassName}`}>
                    {label} {required && <span className="text-red-500">*</span>}
                   
                </label>
            )}
            <div className="flex flex-col">
    <div className={`flex w-full border  rounded-lg overflow-hidden ${error?'border-red-500': 'border-blue-300'}`}>
        
      <Select
        value={countryCode || undefined}
        onChange={onCountryCodeChange}
        placeholder={'+91'}
        className={`w-[85px] border-r border-gray-300 text-[#0f1728] text-sm font-normal font-['Inter'] leading-tight h-[40px] ${error?'bg-white': 'bg-transparent'}`}
        bordered={false}
        size="middle"
        
        optionLabelProp="value"
        dropdownClassName="custom-select-dropdown"
        showSearch
        filterOption={(input, option) =>
            typeof option?.value === 'string' && option.value.toLowerCase().includes(input.toLowerCase())
            // ||            typeof option?.key === 'string' && option.key.toLowerCase().includes(input.toLowerCase())
          }
      >
        {countryOptions.map((option) => (
          <Option key={option.value} value={option.value} label={option.label}>
          {option.value}
        </Option>
        
        ))}
      </Select>

      <Input
        value={phoneNumber}
        onChange={(e) =>
          onPhoneNumberChange(e.target.value.replace(/\D/g, ""))
        }
        variant="filled"
        placeholder={placeholder}
        className={`flex-1 h-[40px] px-3 text-sm text-gray-700 ${error?'bg-white': 'bg-transparent'}`}
        bordered={ false}
      />
    </div>
    {error!=='' && 
                        <div className="text-red-500 text-sm !my-0">{error}</div>}
    </div>
    </div>
  );
};

export default PhoneInputWithCountryCode;
